import { Box, Text } from '@chakra-ui/react';
import React, { useState } from 'react';

import { WipConfig } from '../../types';
import { colors } from 'packages/common-frontend/colors';
import {
  Select,
  formatSelectOptions,
} from 'packages/common-frontend/components/Select';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

export const LoanProductVintageFormulaDenominator = ({
  vintageCurveFormulaDenominator,
  loanProductKey,
  wipConfig,
}: {
  vintageCurveFormulaDenominator: CreditAgreement.Config.LoanProductMechanics.VintageCurveFormulaDenominatorType;
  loanProductKey: string;
  wipConfig?: WipConfig;
}) => {
  const [
    currentVintageCurveFormulaDenominator,
    setCurrentVintageCurveFormulaDenominator,
  ] = useState<CreditAgreement.Config.LoanProductMechanics.VintageCurveFormulaDenominatorType>(
    vintageCurveFormulaDenominator,
  );

  return (
    <>
      <Box mb="35px" width="100%">
        {wipConfig && <></>}
        <Text fontWeight="bold" fontSize="18px" mb="16px">
          Vintage Curve Formula Denominator
        </Text>
        <Text color={colors.black[70]} mb="16px">
          This setting determines the denominator used when calculating Charged
          Off and Delinquency Vintage Curves.
        </Text>

        <Box maxWidth="300px" width="100%">
          <Select
            value={currentVintageCurveFormulaDenominator}
            options={formatSelectOptions(
              CreditAgreement.Config.LoanProductMechanics
                .VintageCurveFormulaDenominatorTypeIterable,
              'title',
            )}
            onChange={(type) => {
              if (type) {
                setCurrentVintageCurveFormulaDenominator(type);
                wipConfig?.formProps.setFieldValue(
                  `${loanProductKey}._config_.vintageCurveFormulaDenominator`,
                  type,
                );
              }
            }}
            isDisabled={!wipConfig}
          />
        </Box>
      </Box>
    </>
  );
};
